export const about = {
  // Hero
  heroTitle: 'حول Dynamix',
  heroSubtitle: 'قيادة مستقبل تعزيز الخرسانة بحلول ألياف الصلب المبتكرة.',
  
  // Our Story
  storyTitle: 'قصتنا',
  storyP1: 'DYNAMIX هي علامة تجارية مبتكرة في إنتاج سلك ألياف الصلب عالي الأداء لهياكل الخرسانة المعززة. تأسست لتقديم حلول تركز على الهندسة لاحتياجات صناعة البناء المتطورة، تبرز Dynamix بمنتجاتها التي تعزز المتانة وتوفر سهولة التطبيق وتوحيد الجودة.',
  storyP2: 'مقرنا في Çorlu، Tekirdağ، نقدم نفساً جديداً لصناعة البناء مع التزامنا بالابتكار والجودة وسلامة الهيكل. منشأة التصنيع الحديثة لدينا تجمع بين التكنولوجيا المتقدمة والحرفية الخبيرة لإنتاج ألياف الصلب التي تلبي أكثر المعايير الدولية صرامة.',
  storyP3: 'نحمل أثر هندستنا في كل ليف صلب وأساس الثقة في كل مشروع.',
  
  // Mission & Vision
  missionTitle: 'مهمتنا',
  missionDesc: 'تقديم حلول ألياف الصلب المبتكرة عالية الجودة التي تعزز متانة وسلامة هياكل الخرسانة في جميع أنحاء العالم. ندمج الجودة ليس فقط في منتجنا ولكن أيضاً في عملياتنا بمبادئ الاستدامة والشفافية.',
  
  visionTitle: 'رؤيتنا',
  visionDesc: 'تمديد عمر الهياكل، وتقليل تكاليف العمالة، وإضافة قيمة للصناعة في تقنيات تعزيز الخرسانة. نهدف إلى أن نكون الرائد العالمي في ابتكار ألياف الصلب، ووضع معايير جديدة للجودة والأداء.',
  
  // Core Values
  valuesTitle: 'قيمنا الأساسية',
  valuesSubtitle: 'المبادئ التي توجه كل ما نقوم به.',
  
  value1Title: 'تميز الجودة',
  value1Desc: 'التزام لا يتزعزع بأعلى معايير التصنيع وجودة المنتج.',
  
  value2Title: 'الابتكار',
  value2Desc: 'البحث والتطوير المستمر لتطوير تقنية تعزيز الخرسانة.',
  
  value3Title: 'النزاهة',
  value3Desc: 'ممارسات تجارية شفافة وعلاقات صادقة مع جميع أصحاب المصلحة.',
  
  value4Title: 'الاستدامة',
  value4Desc: 'المسؤولية البيئية في التصنيع وتعزيز حلول البناء المتينة.',
  
  // Why Choose Us
  whyTitle: 'لماذا تختار Dynamix',
  whySubtitle: 'ما يميزنا في صناعة ألياف الصلب.',
  
  why1Title: 'فريق خبير',
  why1Desc: 'مهندسونا وفنيونا ذوو الخبرة يجلبون عقوداً من الخبرة المجمعة في تقنية تعزيز الخرسانة وعلوم المواد.',
  
  why2Title: 'البنية التحتية الحديثة',
  why2Desc: 'منشأة تصنيع حديثة مجهزة بتكنولوجيا إنتاج متقدمة وأنظمة مراقبة الجودة.',
  
  why3Title: 'المعايير الدولية',
  why3Desc: 'جميع المنتجات مصنعة وفقاً لـ ASTM A820 والمعايير الدولية الأخرى لتعزيز ألياف الصلب.',
  
  why4Title: 'الدعم التقني',
  why4Desc: 'مساعدة تقنية شاملة من تخطيط المشروع حتى التنفيذ، مما يضمن اختيار وتطبيق الألياف الأمثل.',
  
  why5Title: 'التسليم الموثوق',
  why5Desc: 'اللوجستيات الفعالة وإدارة المخزون تضمن التسليم في الوقت المناسب للحفاظ على مشاريع البناء الخاصة بك في الموعد المحدد.',
  
  why6Title: 'التركيز على العملاء',
  why6Desc: 'ملتزمون بفهم وتلبية المتطلبات الفريدة لكل مشروع بحلول مخصصة.',
  
  // CTA
  ctaTitle: 'شراكة مع Dynamix',
  ctaSubtitle: 'انضم إلى العدد المتزايد من محترفي البناء الذين يثقون بـ Dynamix لاحتياجات تعزيز ألياف الصلب الخاصة بهم.',
};

